import React, { SetStateAction } from "react";

interface ContextI {
  impersonatorToken: string | undefined;
  loggedIn: boolean;
  setLoggedIn?: React.Dispatch<SetStateAction<boolean>>;
  setImpersonatorToken?: React.Dispatch<SetStateAction<string>>;
}

const AppContext = React.createContext({
  loggedIn: false,
  setLoggedIn: undefined,
  impersonatorToken: undefined,
  setImpersonatorToken: undefined,
} as ContextI);

export default AppContext;
